/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getBuilding = /* GraphQL */ `
  query GetBuilding($id: ID!) {
    getBuilding(id: $id) {
      Devices {
        items {
          airtable {
            analog_periods_without_data
            authorization_end_date
            automatic_upload
            building_tenths {
              building_tenth
              distribution_tenth
              distribution_tenth_comment
              organisation_tenant
              property_owner_tenth
              site_code
              site_id
              tenth
              __typename
            }
            consumption_2010_10years_in_kwh_pcs
            consumption_2011_10years_in_kwh_pcs
            consumption_2012_10years_in_kwh_pcs
            consumption_2013_10years_in_kwh_pcs
            consumption_2014_10years_in_kwh_pcs
            consumption_2015_10years_in_kwh_pcs
            consumption_2016_10years_in_kwh_pcs
            consumption_2017_10years_in_kwh_pcs
            consumption_2018_10years_in_kwh_pcs
            consumption_2019_10years_in_kwh_pcs
            consumption_2020_10years_in_kwh_pcs
            consumption_2021_10years_in_kwh_pcs
            consumption_2022_10years_in_kwh_pcs
            consumption_2023_10years_in_kwh_pcs
            consumption_2024_10years_in_kwh_pcs
            consumption_or_production
            contextual_information
            contract_holder
            current_synoptic_quality_reporting
            customer_space_available
            deet_category
            delegated_authorization
            deposited
            deposited_date
            destination
            distributor_name
            energy_data_upload_possibilities
            fluid_type
            functional_entities {
              code
              lots
              surface
              tenant_code
              tenant_name
              tertiary
              type
              __typename
            }
            injection_type
            last_analog_invoice_date
            named_authorization
            pdl_id
            perimeter_to_consider
            placement
            quality_of_data_completeness_2023
            questions_about_pdl_to_energy_manager
            site_code
            site_name
            site_rental_typology
            sites {
              address
              city
              code
              current_synoptic_quality_reporting
              id
              name
              organisation_tenant
              postal_code
              __typename
            }
            sub_metering
            supplier_name
            tenth
            unique_point
            usage
            __typename
          }
          analysis {
            meter_commissioning {
              created_at
              text
              __typename
            }
            __typename
          }
          buildingId
          destination
          deviceType
          fluidSupplierId
          fluidType
          fusionedEnergyQuality
          id
          name
          properties {
            id
            name
            quality {
              completenes_end_date
              completenes_start_date
              completeness
              completeness_end_date
              completeness_start_date
              ignored_intervals {
                end_date
                start_date
                __typename
              }
              missing_values
              outliers {
                timestamp
                unit
                value
                __typename
              }
              overall_quality
              overall_quality_reason
              timeseries_end_date
              timeseries_start_date
              __typename
            }
            unit
            value
            __typename
          }
          siteCode
          siteCodes
          siteId
          siteIds
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      id
      location {
        address
        city
        country
        latitude
        longitude
        zipcode
        __typename
      }
      name
      portfolioId
      __typename
    }
  }
`;
export const getCrremObjectivesTable = /* GraphQL */ `
  query GetCrremObjectivesTable($type: CrremUsageEnum) {
    getCrremObjectivesTable(type: $type) {
      energy_2020
      energy_2021
      energy_2022
      energy_2023
      energy_2024
      energy_2025
      energy_2026
      energy_2027
      energy_2028
      energy_2029
      energy_2030
      energy_2031
      energy_2032
      energy_2033
      energy_2034
      energy_2035
      energy_2036
      energy_2037
      energy_2038
      energy_2039
      energy_2040
      energy_2041
      energy_2042
      energy_2043
      energy_2044
      energy_2045
      energy_2046
      energy_2047
      energy_2048
      energy_2049
      energy_2050
      ghg_2020
      ghg_2021
      ghg_2022
      ghg_2023
      ghg_2024
      ghg_2025
      ghg_2026
      ghg_2027
      ghg_2028
      ghg_2029
      ghg_2030
      ghg_2031
      ghg_2032
      ghg_2033
      ghg_2034
      ghg_2035
      ghg_2036
      ghg_2037
      ghg_2038
      ghg_2039
      ghg_2040
      ghg_2041
      ghg_2042
      ghg_2043
      ghg_2044
      ghg_2045
      ghg_2046
      ghg_2047
      ghg_2048
      ghg_2049
      ghg_2050
      usage
      __typename
    }
  }
`;
export const getDevice = /* GraphQL */ `
  query GetDevice($id: ID!) {
    getDevice(id: $id) {
      airtable {
        analog_periods_without_data
        authorization_end_date
        automatic_upload
        building_tenths {
          building_tenth
          distribution_tenth
          distribution_tenth_comment
          organisation_tenant
          property_owner_tenth
          site_code
          site_id
          tenth
          __typename
        }
        consumption_2010_10years_in_kwh_pcs
        consumption_2011_10years_in_kwh_pcs
        consumption_2012_10years_in_kwh_pcs
        consumption_2013_10years_in_kwh_pcs
        consumption_2014_10years_in_kwh_pcs
        consumption_2015_10years_in_kwh_pcs
        consumption_2016_10years_in_kwh_pcs
        consumption_2017_10years_in_kwh_pcs
        consumption_2018_10years_in_kwh_pcs
        consumption_2019_10years_in_kwh_pcs
        consumption_2020_10years_in_kwh_pcs
        consumption_2021_10years_in_kwh_pcs
        consumption_2022_10years_in_kwh_pcs
        consumption_2023_10years_in_kwh_pcs
        consumption_2024_10years_in_kwh_pcs
        consumption_or_production
        contextual_information
        contract_holder
        current_synoptic_quality_reporting
        customer_space_available
        deet_category
        delegated_authorization
        deposited
        deposited_date
        destination
        distributor_name
        energy_data_upload_possibilities
        fluid_type
        functional_entities {
          code
          lots
          surface
          tenant_code
          tenant_name
          tertiary
          type
          __typename
        }
        injection_type
        last_analog_invoice_date
        named_authorization
        pdl_id
        perimeter_to_consider
        placement
        quality_of_data_completeness_2023
        questions_about_pdl_to_energy_manager
        site_code
        site_name
        site_rental_typology
        sites {
          address
          city
          code
          current_synoptic_quality_reporting
          id
          name
          organisation_tenant
          postal_code
          __typename
        }
        sub_metering
        supplier_name
        tenth
        unique_point
        usage
        __typename
      }
      analysis {
        meter_commissioning {
          created_at
          text
          __typename
        }
        __typename
      }
      buildingId
      destination
      deviceType
      fluidSupplierId
      fluidType
      fusionedEnergyQuality
      id
      name
      properties {
        id
        name
        quality {
          completenes_end_date
          completenes_start_date
          completeness
          completeness_end_date
          completeness_start_date
          ignored_intervals {
            end_date
            start_date
            __typename
          }
          missing_values
          outliers {
            timestamp
            unit
            value
            __typename
          }
          overall_quality
          overall_quality_reason
          timeseries_end_date
          timeseries_start_date
          __typename
        }
        unit
        value
        __typename
      }
      siteCode
      siteCodes
      siteId
      siteIds
      __typename
    }
  }
`;
export const getDeviceContract = /* GraphQL */ `
  query GetDeviceContract($id: ID!) {
    getDeviceContract(id: $id) {
      contracts {
        car
        cja
        date_mes
        profil {
          profil_type_actuel
          __typename
        }
        tarif_acheminement
        __typename
      }
      donneesGenerales {
        adresseInstallation {
          batiment
          codePostal
          commune {
            code
            libelle
            __typename
          }
          escalierEtEtageEtAppartement
          numeroEtNomVoie
          __typename
        }
        dateDerniereModificationFormuleTarifaireAcheminement
        etatContractuel {
          code
          libelle
          __typename
        }
        niveauOuvertureServices
        segment {
          code
          libelle
          __typename
        }
        __typename
      }
      pdl_id
      permissions {
        code_postal
        courrier_titulaire
        date_creation
        date_debut_droit_acces
        date_fin_droit_acces
        date_limite_transmission_preuve
        date_passage_a_obsolete
        date_passage_a_refuse
        date_revocation
        etat_droit_acces
        id_droit_acces
        id_pce
        nom_titulaire
        numero_telephone_mobile_titulaire
        parcours
        perim_donnees_conso_debut
        perim_donnees_conso_fin
        perim_donnees_contractuelles
        perim_donnees_informatives
        perim_donnees_publiees
        perim_donnees_techniques
        raison_sociale_du_tiers
        raison_sociale_du_titulaire
        role_tiers
        source_passage_a_obsolete
        source_passage_a_refuse
        source_revocation
        statut_controle_preuve
        __typename
      }
      situationAlimentation {
        alimentationPrincipale {
          domaineTension {
            code
            libelle
            __typename
          }
          puissanceRaccordementSoutirage {
            unite
            valeur
            __typename
          }
          tensionLivraison {
            code
            libelle
            __typename
          }
          __typename
        }
        __typename
      }
      situationComptage {
        caracteristiquesReleve {
          modeTraitement {
            code
            libelle
            __typename
          }
          periodicite {
            code
            libelle
            __typename
          }
          plageReleve {
            code
            libelle
            __typename
          }
          __typename
        }
        dispositifComptage {
          compteurs {
            compteur {
              localisation {
                code
                libelle
                __typename
              }
              matricule
              parametresTeleAcces {
                cle
                etatLigneTelephonique
                __typename
              }
              programmationHoraire {
                programmationPosteHoraire {
                  code
                  libelle
                  periodesHoraires
                  __typename
                }
                __typename
              }
              ticActivable
              ticActivee
              ticStandard
              __typename
            }
            typeComptage {
              code
              libelle
              __typename
            }
            __typename
          }
          disjoncteur {
            calibre {
              code
              libelle
              __typename
            }
            __typename
          }
          relais {
            plageHeuresCreuses
            __typename
          }
          typeComptage {
            code
            libelle
            __typename
          }
          __typename
        }
        futuresPlagesHeuresCreuses {
          code
          libelle
          __typename
        }
        futuresProgrammationsHoraires {
          formuleTarifaireAcheminement {
            code
            libelle
            programmationHoraire {
              programmationPosteHoraire {
                code
                libelle
                periodesHoraires
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        mediaReleve {
          code
          libelle
          __typename
        }
        modeReleve {
          code
          libelle
          __typename
        }
        transformateurCourant {
          calibre {
            code
            libelle
            __typename
          }
          classePrecision {
            code
            libelle
            __typename
          }
          couplage {
            code
            libelle
            __typename
          }
          position {
            code
            libelle
            __typename
          }
          __typename
        }
        __typename
      }
      situationContractuelle {
        structureTarifaire {
          calendrierFrn {
            code
            libelle
            __typename
          }
          denivelePuissances {
            classesTemporelles {
              classeTemporelle {
                code
                libelle
                puissance {
                  unite
                  valeur
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          formuleTarifaireAcheminement {
            code
            libelle
            __typename
          }
          puissanceSouscriteMax {
            unite
            valeur
            __typename
          }
          __typename
        }
        __typename
      }
      technical {
        caracteristiques_compteur {
          client_sensible_mig
          frequence
          __typename
        }
        pitd {
          identifiant_pitd
          libelle_pitd
          __typename
        }
        situation_compteur {
          code_postal
          commune
          complement_adresse
          nom_rue
          numero_rue
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getDevicePropertyTimeseries = /* GraphQL */ `
  query GetDevicePropertyTimeseries(
    $aggregation: AggregationTimeseries
    $deviceId: ID!
    $propertyId: ID!
    $timestamp: AWSDateTimeInput
  ) {
    getDevicePropertyTimeseries(
      aggregation: $aggregation
      deviceId: $deviceId
      propertyId: $propertyId
      timestamp: $timestamp
    ) {
      deviceId
      id
      nextToken
      pagination {
        nextToken
        startedAt
        __typename
      }
      propertyId
      timeseries {
        grid_name
        likelihood_index_season_base
        likelihood_index_season_hc
        likelihood_index_season_hcb
        likelihood_index_season_hce
        likelihood_index_season_hch
        likelihood_index_season_hp
        likelihood_index_season_hpb
        likelihood_index_season_hpe
        likelihood_index_season_hph
        likelihood_index_season_ja
        likelihood_index_season_p
        likelihood_index_season_pointe
        monotone_cumulative_time_in_min
        monotone_end_date
        monotone_execution_time
        monotone_start_date
        nature
        read_reason
        reason
        sampling_rate_in_min
        season_class_dict
        source
        time
        value
        value_nature_absence
        value_nature_actual
        value_nature_brut
        value_nature_corrected
        value_nature_corrige
        value_nature_coupure_secteur
        value_nature_coupure_secteur_courte
        value_nature_debut_de_coupure_secteur
        value_nature_esti
        value_nature_estimated
        value_nature_estime
        value_nature_fin_de_coupure_secteur
        value_nature_importe_manuellement_par_le_metier_enedis
        value_nature_no_data
        value_nature_puissance_reconstituee_et_coupure_secteur
        value_nature_reel
        value_nature_regu
        value_season_base
        value_season_hc
        value_season_hcb
        value_season_hce
        value_season_hch
        value_season_hp
        value_season_hpb
        value_season_hpe
        value_season_hph
        value_season_ja
        value_season_p
        value_season_pointe
        value_source_airtable_manual_bills
        value_source_airtable_third_party_active_power_in_kwh
        value_source_airtable_third_party_energy
        value_source_enedis_active_power_daily_in_kwh
        value_source_enedis_billed_energy
        __typename
      }
      unit
      __typename
    }
  }
`;
export const getDevicePropertyTimeseriesAsync = /* GraphQL */ `
  query GetDevicePropertyTimeseriesAsync(
    $aggregation: AggregationTimeseries
    $deviceId: ID!
    $propertyId: ID!
    $timestamp: AWSDateTimeInput
  ) {
    getDevicePropertyTimeseriesAsync(
      aggregation: $aggregation
      deviceId: $deviceId
      propertyId: $propertyId
      timestamp: $timestamp
    ) {
      chunkCurrent
      chunkTotal
      status
      token
      __typename
    }
  }
`;
export const getDeviceQualityReasoning = /* GraphQL */ `
  query GetDeviceQualityReasoning(
    $id: ID!
    $reasoningId: ID
    $reasoningType: String
  ) {
    getDeviceQualityReasoning(
      id: $id
      reasoningId: $reasoningId
      reasoningType: $reasoningType
    ) {
      items {
        createAt
        endDate
        id
        outdated
        reasoningId
        reasoningText
        reasoningType
        reviewed
        startDate
        updateBy
        updatedAt
        value
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getDeviceSubdevicesTimeseries = /* GraphQL */ `
  query GetDeviceSubdevicesTimeseries(
    $id: ID!
    $nextToken: String
    $time: AWSDateTimeInput
  ) {
    getDeviceSubdevicesTimeseries(id: $id, nextToken: $nextToken, time: $time) {
      items {
        deviceId
        id
        nextToken
        pagination {
          nextToken
          startedAt
          __typename
        }
        propertyId
        timeseries {
          grid_name
          likelihood_index_season_base
          likelihood_index_season_hc
          likelihood_index_season_hcb
          likelihood_index_season_hce
          likelihood_index_season_hch
          likelihood_index_season_hp
          likelihood_index_season_hpb
          likelihood_index_season_hpe
          likelihood_index_season_hph
          likelihood_index_season_ja
          likelihood_index_season_p
          likelihood_index_season_pointe
          monotone_cumulative_time_in_min
          monotone_end_date
          monotone_execution_time
          monotone_start_date
          nature
          read_reason
          reason
          sampling_rate_in_min
          season_class_dict
          source
          time
          value
          value_nature_absence
          value_nature_actual
          value_nature_brut
          value_nature_corrected
          value_nature_corrige
          value_nature_coupure_secteur
          value_nature_coupure_secteur_courte
          value_nature_debut_de_coupure_secteur
          value_nature_esti
          value_nature_estimated
          value_nature_estime
          value_nature_fin_de_coupure_secteur
          value_nature_importe_manuellement_par_le_metier_enedis
          value_nature_no_data
          value_nature_puissance_reconstituee_et_coupure_secteur
          value_nature_reel
          value_nature_regu
          value_season_base
          value_season_hc
          value_season_hcb
          value_season_hce
          value_season_hch
          value_season_hp
          value_season_hpb
          value_season_hpe
          value_season_hph
          value_season_ja
          value_season_p
          value_season_pointe
          value_source_airtable_manual_bills
          value_source_airtable_third_party_active_power_in_kwh
          value_source_airtable_third_party_energy
          value_source_enedis_active_power_daily_in_kwh
          value_source_enedis_billed_energy
          __typename
        }
        unit
        __typename
      }
      nextToken
      scannedCount
      startedAt
      __typename
    }
  }
`;
export const getDpeTable = /* GraphQL */ `
  query GetDpeTable($type: DpeUsageEnum) {
    getDpeTable(type: $type) {
      energy_a
      energy_b
      energy_c
      energy_d
      energy_e
      energy_f
      ghg_a
      ghg_b
      ghg_c
      ghg_d
      ghg_e
      ghg_f
      usage
      __typename
    }
  }
`;
export const getSite = /* GraphQL */ `
  query GetSite($id: ID!) {
    getSite(id: $id) {
      airtable {
        acquisition_date
        address
        aegeon_energy_data_type
        altitude
        asl_aful_names
        asl_and_aful {
          name
          type
          __typename
        }
        asset_manager_contact {
          email
          name
          organizations_names
          phone_number
          role
          __typename
        }
        billing_contact {
          email
          name
          organizations_names
          phone_number
          role
          __typename
        }
        biodiversity_label
        building_site_plan
        city
        closing_hours
        co2_perf_bpe_oid_ref
        co_ownership {
          name
          type
          __typename
        }
        co_ownership_name
        code
        commissioning_and_reporting_note_2023
        construction_certification
        construction_date
        consumption_or_production
        counted_rental_typology
        crrem_typology
        current_synoptic_quality_reporting
        current_typology
        declared_detention_regime
        declared_ef_rental_areas
        declared_rental_typology
        deet_geographic_zone
        deet_subject
        deet_subject_case
        detention_contextual_information
        discontinued_data_questions
        disposal_date
        dpe_emissions
        dpe_energy
        efa_type
        energisme_energy_data_type
        energy_data_upload_possibilities
        esg_modality {
          name
          __typename
        }
        exhaustiveness_remaining_questions
        exploitation_certification
        final_energy_perf_bpe_oid_ref
        fluids_typology
        functional_entities {
          code
          lots
          surface
          tenant_code
          tenant_name
          tertiary
          type
          __typename
        }
        functional_entities_state_date
        google_maps_url
        gtb_presence
        indoor_parking
        initial_building_permit_date
        irves_presence
        last_dpe_date
        last_renovation_date
        latitude
        longitude
        maintainers_intervenants_contact {
          email
          name
          organizations_names
          phone_number
          role
          __typename
        }
        maintenance_company
        mandates_questions
        monitored_perimeter
        name
        number_of_buildings
        number_of_buildings_client
        number_of_indoor_parkings
        number_of_outdoor_parkings
        number_of_potentially_subjected_functional_entities
        number_of_tenants_following_rental_state_ex_parking
        opening_hours
        organization_type
        organizations {
          name
          type
          __typename
        }
        outdoor_parking
        perimeter_2023
        photovoltaic_presence
        postal_code
        powerpoint_synoptic
        previous_year_synoptic_validation
        property_manager_agency {
          name
          type
          __typename
        }
        property_manager_contact {
          email
          name
          organizations_names
          phone_number
          role
          __typename
        }
        reference_weather_station_city
        remaining_site_questions
        rental_manager_contact {
          email
          name
          organizations_names
          phone_number
          role
          __typename
        }
        rental_occupation_rate_2019
        rental_occupation_rate_2020
        rental_occupation_rate_2021
        rental_occupation_rate_2022
        rental_occupation_rate_2023
        rental_occupation_rate_2024
        reporting_end_date
        reporting_n_1_surface_energy_performance
        reporting_n_2_surface_energy_performance
        reporting_n_carbon_intensity
        reporting_n_reportable_site
        reporting_n_surface_energy_performance
        reporting_n_total_energy_consumption
        reporting_n_total_ghg_emissions
        reporting_n_total_water_consumption
        reporting_start_date
        rie_exploitation {
          name
          type
          __typename
        }
        rie_presence
        stakeholders_update_date
        synoptic_quality_reporting_2023
        synoptic_validation_note_2022_2023
        technical_assistant_contact {
          email
          name
          organizations_names
          phone_number
          role
          __typename
        }
        technical_contact {
          email
          name
          organizations_names
          phone_number
          role
          __typename
        }
        technical_documentation_technical_written_elements
        thermal_regulation
        third_party_parts_supply
        unified_degree_day_weather_station {
          city
          code
          __typename
        }
        updated_previous_year_tracking
        updated_year_tracking
        usage_crrem
        usage_dpe
        validated_client_hours
        validated_client_surface
        validated_client_working_days
        water_perf_bpe_oid_ref
        working_days
        year_synoptic_validation
        __typename
      }
      analysis {
        general {
          created_at
          text
          __typename
        }
        __typename
      }
      id
      name
      portfolioId
      properties {
        id
        name
        quality {
          completenes_end_date
          completenes_start_date
          completeness
          completeness_end_date
          completeness_start_date
          ignored_intervals {
            end_date
            start_date
            __typename
          }
          missing_values
          outliers {
            timestamp
            unit
            value
            __typename
          }
          overall_quality
          overall_quality_reason
          timeseries_end_date
          timeseries_start_date
          __typename
        }
        unit
        value
        __typename
      }
      __typename
    }
  }
`;
export const getSiteAggElecTimeseries = /* GraphQL */ `
  query GetSiteAggElecTimeseries($id: ID!, $time: AWSDateTimeInput) {
    getSiteAggElecTimeseries(id: $id, time: $time) {
      deviceId
      id
      nextToken
      pagination {
        nextToken
        startedAt
        __typename
      }
      propertyId
      timeseries {
        grid_name
        likelihood_index_season_base
        likelihood_index_season_hc
        likelihood_index_season_hcb
        likelihood_index_season_hce
        likelihood_index_season_hch
        likelihood_index_season_hp
        likelihood_index_season_hpb
        likelihood_index_season_hpe
        likelihood_index_season_hph
        likelihood_index_season_ja
        likelihood_index_season_p
        likelihood_index_season_pointe
        monotone_cumulative_time_in_min
        monotone_end_date
        monotone_execution_time
        monotone_start_date
        nature
        read_reason
        reason
        sampling_rate_in_min
        season_class_dict
        source
        time
        value
        value_nature_absence
        value_nature_actual
        value_nature_brut
        value_nature_corrected
        value_nature_corrige
        value_nature_coupure_secteur
        value_nature_coupure_secteur_courte
        value_nature_debut_de_coupure_secteur
        value_nature_esti
        value_nature_estimated
        value_nature_estime
        value_nature_fin_de_coupure_secteur
        value_nature_importe_manuellement_par_le_metier_enedis
        value_nature_no_data
        value_nature_puissance_reconstituee_et_coupure_secteur
        value_nature_reel
        value_nature_regu
        value_season_base
        value_season_hc
        value_season_hcb
        value_season_hce
        value_season_hch
        value_season_hp
        value_season_hpb
        value_season_hpe
        value_season_hph
        value_season_ja
        value_season_p
        value_season_pointe
        value_source_airtable_manual_bills
        value_source_airtable_third_party_active_power_in_kwh
        value_source_airtable_third_party_energy
        value_source_enedis_active_power_daily_in_kwh
        value_source_enedis_billed_energy
        __typename
      }
      unit
      __typename
    }
  }
`;
export const getSiteCrremObjectivesTable = /* GraphQL */ `
  query GetSiteCrremObjectivesTable($id: ID!) {
    getSiteCrremObjectivesTable(id: $id) {
      energy_2020
      energy_2021
      energy_2022
      energy_2023
      energy_2024
      energy_2025
      energy_2026
      energy_2027
      energy_2028
      energy_2029
      energy_2030
      energy_2031
      energy_2032
      energy_2033
      energy_2034
      energy_2035
      energy_2036
      energy_2037
      energy_2038
      energy_2039
      energy_2040
      energy_2041
      energy_2042
      energy_2043
      energy_2044
      energy_2045
      energy_2046
      energy_2047
      energy_2048
      energy_2049
      energy_2050
      ghg_2020
      ghg_2021
      ghg_2022
      ghg_2023
      ghg_2024
      ghg_2025
      ghg_2026
      ghg_2027
      ghg_2028
      ghg_2029
      ghg_2030
      ghg_2031
      ghg_2032
      ghg_2033
      ghg_2034
      ghg_2035
      ghg_2036
      ghg_2037
      ghg_2038
      ghg_2039
      ghg_2040
      ghg_2041
      ghg_2042
      ghg_2043
      ghg_2044
      ghg_2045
      ghg_2046
      ghg_2047
      ghg_2048
      ghg_2049
      ghg_2050
      usage
      __typename
    }
  }
`;
export const getSiteDevicesTimeseries = /* GraphQL */ `
  query GetSiteDevicesTimeseries(
    $id: ID!
    $nextToken: String
    $time: AWSDateTimeInput
  ) {
    getSiteDevicesTimeseries(id: $id, nextToken: $nextToken, time: $time) {
      items {
        deviceId
        id
        nextToken
        pagination {
          nextToken
          startedAt
          __typename
        }
        propertyId
        timeseries {
          grid_name
          likelihood_index_season_base
          likelihood_index_season_hc
          likelihood_index_season_hcb
          likelihood_index_season_hce
          likelihood_index_season_hch
          likelihood_index_season_hp
          likelihood_index_season_hpb
          likelihood_index_season_hpe
          likelihood_index_season_hph
          likelihood_index_season_ja
          likelihood_index_season_p
          likelihood_index_season_pointe
          monotone_cumulative_time_in_min
          monotone_end_date
          monotone_execution_time
          monotone_start_date
          nature
          read_reason
          reason
          sampling_rate_in_min
          season_class_dict
          source
          time
          value
          value_nature_absence
          value_nature_actual
          value_nature_brut
          value_nature_corrected
          value_nature_corrige
          value_nature_coupure_secteur
          value_nature_coupure_secteur_courte
          value_nature_debut_de_coupure_secteur
          value_nature_esti
          value_nature_estimated
          value_nature_estime
          value_nature_fin_de_coupure_secteur
          value_nature_importe_manuellement_par_le_metier_enedis
          value_nature_no_data
          value_nature_puissance_reconstituee_et_coupure_secteur
          value_nature_reel
          value_nature_regu
          value_season_base
          value_season_hc
          value_season_hcb
          value_season_hce
          value_season_hch
          value_season_hp
          value_season_hpb
          value_season_hpe
          value_season_hph
          value_season_ja
          value_season_p
          value_season_pointe
          value_source_airtable_manual_bills
          value_source_airtable_third_party_active_power_in_kwh
          value_source_airtable_third_party_energy
          value_source_enedis_active_power_daily_in_kwh
          value_source_enedis_billed_energy
          __typename
        }
        unit
        __typename
      }
      nextToken
      scannedCount
      startedAt
      __typename
    }
  }
`;
export const getSiteDjrTimeseries = /* GraphQL */ `
  query GetSiteDjrTimeseries($id: ID!, $time: AWSDateTimeInput) {
    getSiteDjrTimeseries(id: $id, time: $time) {
      deviceId
      id
      nextToken
      pagination {
        nextToken
        startedAt
        __typename
      }
      propertyId
      timeseries {
        grid_name
        likelihood_index_season_base
        likelihood_index_season_hc
        likelihood_index_season_hcb
        likelihood_index_season_hce
        likelihood_index_season_hch
        likelihood_index_season_hp
        likelihood_index_season_hpb
        likelihood_index_season_hpe
        likelihood_index_season_hph
        likelihood_index_season_ja
        likelihood_index_season_p
        likelihood_index_season_pointe
        monotone_cumulative_time_in_min
        monotone_end_date
        monotone_execution_time
        monotone_start_date
        nature
        read_reason
        reason
        sampling_rate_in_min
        season_class_dict
        source
        time
        value
        value_nature_absence
        value_nature_actual
        value_nature_brut
        value_nature_corrected
        value_nature_corrige
        value_nature_coupure_secteur
        value_nature_coupure_secteur_courte
        value_nature_debut_de_coupure_secteur
        value_nature_esti
        value_nature_estimated
        value_nature_estime
        value_nature_fin_de_coupure_secteur
        value_nature_importe_manuellement_par_le_metier_enedis
        value_nature_no_data
        value_nature_puissance_reconstituee_et_coupure_secteur
        value_nature_reel
        value_nature_regu
        value_season_base
        value_season_hc
        value_season_hcb
        value_season_hce
        value_season_hch
        value_season_hp
        value_season_hpb
        value_season_hpe
        value_season_hph
        value_season_ja
        value_season_p
        value_season_pointe
        value_source_airtable_manual_bills
        value_source_airtable_third_party_active_power_in_kwh
        value_source_airtable_third_party_energy
        value_source_enedis_active_power_daily_in_kwh
        value_source_enedis_billed_energy
        __typename
      }
      unit
      __typename
    }
  }
`;
export const getSiteDjuTimeseries = /* GraphQL */ `
  query GetSiteDjuTimeseries($id: ID!, $time: AWSDateTimeInput) {
    getSiteDjuTimeseries(id: $id, time: $time) {
      deviceId
      id
      nextToken
      pagination {
        nextToken
        startedAt
        __typename
      }
      propertyId
      timeseries {
        grid_name
        likelihood_index_season_base
        likelihood_index_season_hc
        likelihood_index_season_hcb
        likelihood_index_season_hce
        likelihood_index_season_hch
        likelihood_index_season_hp
        likelihood_index_season_hpb
        likelihood_index_season_hpe
        likelihood_index_season_hph
        likelihood_index_season_ja
        likelihood_index_season_p
        likelihood_index_season_pointe
        monotone_cumulative_time_in_min
        monotone_end_date
        monotone_execution_time
        monotone_start_date
        nature
        read_reason
        reason
        sampling_rate_in_min
        season_class_dict
        source
        time
        value
        value_nature_absence
        value_nature_actual
        value_nature_brut
        value_nature_corrected
        value_nature_corrige
        value_nature_coupure_secteur
        value_nature_coupure_secteur_courte
        value_nature_debut_de_coupure_secteur
        value_nature_esti
        value_nature_estimated
        value_nature_estime
        value_nature_fin_de_coupure_secteur
        value_nature_importe_manuellement_par_le_metier_enedis
        value_nature_no_data
        value_nature_puissance_reconstituee_et_coupure_secteur
        value_nature_reel
        value_nature_regu
        value_season_base
        value_season_hc
        value_season_hcb
        value_season_hce
        value_season_hch
        value_season_hp
        value_season_hpb
        value_season_hpe
        value_season_hph
        value_season_ja
        value_season_p
        value_season_pointe
        value_source_airtable_manual_bills
        value_source_airtable_third_party_active_power_in_kwh
        value_source_airtable_third_party_energy
        value_source_enedis_active_power_daily_in_kwh
        value_source_enedis_billed_energy
        __typename
      }
      unit
      __typename
    }
  }
`;
export const getSiteDpeTable = /* GraphQL */ `
  query GetSiteDpeTable($id: ID!) {
    getSiteDpeTable(id: $id) {
      energy_a
      energy_b
      energy_c
      energy_d
      energy_e
      energy_f
      ghg_a
      ghg_b
      ghg_c
      ghg_d
      ghg_e
      ghg_f
      usage
      __typename
    }
  }
`;
export const getSitePerformances = /* GraphQL */ `
  query GetSitePerformances(
    $id: ID!
    $time: AWSDateTimeInput
    $types: [PerformanceClassEnum]!
  ) {
    getSitePerformances(id: $id, time: $time, types: $types) {
      id
      performances {
        type
        unit
        value
        values {
          value
          year
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getSiteTimeseries = /* GraphQL */ `
  query GetSiteTimeseries(
    $aggregation: AggregationTimeseries
    $id: ID!
    $nextToken: String
    $time: AWSDateTimeInput
  ) {
    getSiteTimeseries(
      aggregation: $aggregation
      id: $id
      nextToken: $nextToken
      time: $time
    ) {
      items {
        aggDestination {
          deposited {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          out_of_scope {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          private {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          private_vacant {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          private_vacant_shared {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          shared {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          sum
          third_party {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          __typename
        }
        aggFluid {
          butane {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          coal {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          cold {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          electricity {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          fod {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          gaz {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          heat {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          otherFossileFuel {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          propane {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          sum
          water {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          wood {
            value
            value_reason_airtable_manual_bills
            value_reason_third_party_energy
            __typename
          }
          __typename
        }
        aggFluidDestination {
          butane {
            deposited {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            out_of_scope {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant_shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            sum
            third_party {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            __typename
          }
          coal {
            deposited {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            out_of_scope {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant_shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            sum
            third_party {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            __typename
          }
          cold {
            deposited {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            out_of_scope {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant_shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            sum
            third_party {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            __typename
          }
          electricity {
            deposited {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            out_of_scope {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant_shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            sum
            third_party {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            __typename
          }
          fod {
            deposited {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            out_of_scope {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant_shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            sum
            third_party {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            __typename
          }
          gaz {
            deposited {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            out_of_scope {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant_shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            sum
            third_party {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            __typename
          }
          heat {
            deposited {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            out_of_scope {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant_shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            sum
            third_party {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            __typename
          }
          otherFossileFuel {
            deposited {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            out_of_scope {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant_shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            sum
            third_party {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            __typename
          }
          propane {
            deposited {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            out_of_scope {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant_shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            sum
            third_party {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            __typename
          }
          sum {
            deposited {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            out_of_scope {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant_shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            sum
            third_party {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            __typename
          }
          water {
            deposited {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            out_of_scope {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant_shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            sum
            third_party {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            __typename
          }
          wood {
            deposited {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            out_of_scope {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            private_vacant_shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            shared {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            sum
            third_party {
              value
              value_reason_airtable_manual_bills
              value_reason_third_party_energy
              __typename
            }
            __typename
          }
          __typename
        }
        id
        time
        unit
        value
        __typename
      }
      nextToken
      scannedCount
      startedAt
      __typename
    }
  }
`;
export const getSubdevice = /* GraphQL */ `
  query GetSubdevice($id: ID!) {
    getSubdevice(id: $id) {
      building
      contract_holder
      description
      deviceId
      id
      lessor
      name
      siteId
      __typename
    }
  }
`;
export const getSubdeviceTimeseries = /* GraphQL */ `
  query GetSubdeviceTimeseries(
    $id: ID!
    $nextToken: String
    $time: AWSDateTimeInput
  ) {
    getSubdeviceTimeseries(id: $id, nextToken: $nextToken, time: $time) {
      deviceId
      id
      nextToken
      pagination {
        nextToken
        startedAt
        __typename
      }
      propertyId
      timeseries {
        grid_name
        likelihood_index_season_base
        likelihood_index_season_hc
        likelihood_index_season_hcb
        likelihood_index_season_hce
        likelihood_index_season_hch
        likelihood_index_season_hp
        likelihood_index_season_hpb
        likelihood_index_season_hpe
        likelihood_index_season_hph
        likelihood_index_season_ja
        likelihood_index_season_p
        likelihood_index_season_pointe
        monotone_cumulative_time_in_min
        monotone_end_date
        monotone_execution_time
        monotone_start_date
        nature
        read_reason
        reason
        sampling_rate_in_min
        season_class_dict
        source
        time
        value
        value_nature_absence
        value_nature_actual
        value_nature_brut
        value_nature_corrected
        value_nature_corrige
        value_nature_coupure_secteur
        value_nature_coupure_secteur_courte
        value_nature_debut_de_coupure_secteur
        value_nature_esti
        value_nature_estimated
        value_nature_estime
        value_nature_fin_de_coupure_secteur
        value_nature_importe_manuellement_par_le_metier_enedis
        value_nature_no_data
        value_nature_puissance_reconstituee_et_coupure_secteur
        value_nature_reel
        value_nature_regu
        value_season_base
        value_season_hc
        value_season_hcb
        value_season_hce
        value_season_hch
        value_season_hp
        value_season_hpb
        value_season_hpe
        value_season_hph
        value_season_ja
        value_season_p
        value_season_pointe
        value_source_airtable_manual_bills
        value_source_airtable_third_party_active_power_in_kwh
        value_source_airtable_third_party_energy
        value_source_enedis_active_power_daily_in_kwh
        value_source_enedis_billed_energy
        __typename
      }
      unit
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!, $username: String!) {
    getUser(id: $id, username: $username) {
      email
      enabled
      excludedPerimeter {
        devices
        sites
        __typename
      }
      id
      lastConnectionAt
      perimeter {
        devices
        sites
        __typename
      }
      role
      timeConstraintPerimeter {
        devices {
          id
          periods {
            endDate
            startDate
            __typename
          }
          __typename
        }
        sites {
          id
          periods {
            endDate
            startDate
            __typename
          }
          __typename
        }
        __typename
      }
      username
      __typename
    }
  }
`;
export const listBuildings = /* GraphQL */ `
  query ListBuildings(
    $filter: BuildingFilterInput
    $limit: Int
    $sort: SortInput
  ) {
    listBuildings(filter: $filter, limit: $limit, sort: $sort) {
      items {
        Devices {
          items {
            airtable {
              analog_periods_without_data
              authorization_end_date
              automatic_upload
              building_tenths {
                building_tenth
                distribution_tenth
                distribution_tenth_comment
                organisation_tenant
                property_owner_tenth
                site_code
                site_id
                tenth
                __typename
              }
              consumption_2010_10years_in_kwh_pcs
              consumption_2011_10years_in_kwh_pcs
              consumption_2012_10years_in_kwh_pcs
              consumption_2013_10years_in_kwh_pcs
              consumption_2014_10years_in_kwh_pcs
              consumption_2015_10years_in_kwh_pcs
              consumption_2016_10years_in_kwh_pcs
              consumption_2017_10years_in_kwh_pcs
              consumption_2018_10years_in_kwh_pcs
              consumption_2019_10years_in_kwh_pcs
              consumption_2020_10years_in_kwh_pcs
              consumption_2021_10years_in_kwh_pcs
              consumption_2022_10years_in_kwh_pcs
              consumption_2023_10years_in_kwh_pcs
              consumption_2024_10years_in_kwh_pcs
              consumption_or_production
              contextual_information
              contract_holder
              current_synoptic_quality_reporting
              customer_space_available
              deet_category
              delegated_authorization
              deposited
              deposited_date
              destination
              distributor_name
              energy_data_upload_possibilities
              fluid_type
              functional_entities {
                code
                lots
                surface
                tenant_code
                tenant_name
                tertiary
                type
                __typename
              }
              injection_type
              last_analog_invoice_date
              named_authorization
              pdl_id
              perimeter_to_consider
              placement
              quality_of_data_completeness_2023
              questions_about_pdl_to_energy_manager
              site_code
              site_name
              site_rental_typology
              sites {
                address
                city
                code
                current_synoptic_quality_reporting
                id
                name
                organisation_tenant
                postal_code
                __typename
              }
              sub_metering
              supplier_name
              tenth
              unique_point
              usage
              __typename
            }
            analysis {
              meter_commissioning {
                created_at
                text
                __typename
              }
              __typename
            }
            buildingId
            destination
            deviceType
            fluidSupplierId
            fluidType
            fusionedEnergyQuality
            id
            name
            properties {
              id
              name
              quality {
                completenes_end_date
                completenes_start_date
                completeness
                completeness_end_date
                completeness_start_date
                ignored_intervals {
                  end_date
                  start_date
                  __typename
                }
                missing_values
                outliers {
                  timestamp
                  unit
                  value
                  __typename
                }
                overall_quality
                overall_quality_reason
                timeseries_end_date
                timeseries_start_date
                __typename
              }
              unit
              value
              __typename
            }
            siteCode
            siteCodes
            siteId
            siteIds
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        id
        location {
          address
          city
          country
          latitude
          longitude
          zipcode
          __typename
        }
        name
        portfolioId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const listDevices = /* GraphQL */ `
  query ListDevices(
    $filter: DeviceFilterInput
    $limit: Int
    $nextToken: String
    $sort: SortInput
  ) {
    listDevices(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sort: $sort
    ) {
      items {
        airtable {
          analog_periods_without_data
          authorization_end_date
          automatic_upload
          building_tenths {
            building_tenth
            distribution_tenth
            distribution_tenth_comment
            organisation_tenant
            property_owner_tenth
            site_code
            site_id
            tenth
            __typename
          }
          consumption_2010_10years_in_kwh_pcs
          consumption_2011_10years_in_kwh_pcs
          consumption_2012_10years_in_kwh_pcs
          consumption_2013_10years_in_kwh_pcs
          consumption_2014_10years_in_kwh_pcs
          consumption_2015_10years_in_kwh_pcs
          consumption_2016_10years_in_kwh_pcs
          consumption_2017_10years_in_kwh_pcs
          consumption_2018_10years_in_kwh_pcs
          consumption_2019_10years_in_kwh_pcs
          consumption_2020_10years_in_kwh_pcs
          consumption_2021_10years_in_kwh_pcs
          consumption_2022_10years_in_kwh_pcs
          consumption_2023_10years_in_kwh_pcs
          consumption_2024_10years_in_kwh_pcs
          consumption_or_production
          contextual_information
          contract_holder
          current_synoptic_quality_reporting
          customer_space_available
          deet_category
          delegated_authorization
          deposited
          deposited_date
          destination
          distributor_name
          energy_data_upload_possibilities
          fluid_type
          functional_entities {
            code
            lots
            surface
            tenant_code
            tenant_name
            tertiary
            type
            __typename
          }
          injection_type
          last_analog_invoice_date
          named_authorization
          pdl_id
          perimeter_to_consider
          placement
          quality_of_data_completeness_2023
          questions_about_pdl_to_energy_manager
          site_code
          site_name
          site_rental_typology
          sites {
            address
            city
            code
            current_synoptic_quality_reporting
            id
            name
            organisation_tenant
            postal_code
            __typename
          }
          sub_metering
          supplier_name
          tenth
          unique_point
          usage
          __typename
        }
        analysis {
          meter_commissioning {
            created_at
            text
            __typename
          }
          __typename
        }
        buildingId
        destination
        deviceType
        fluidSupplierId
        fluidType
        fusionedEnergyQuality
        id
        name
        properties {
          id
          name
          quality {
            completenes_end_date
            completenes_start_date
            completeness
            completeness_end_date
            completeness_start_date
            ignored_intervals {
              end_date
              start_date
              __typename
            }
            missing_values
            outliers {
              timestamp
              unit
              value
              __typename
            }
            overall_quality
            overall_quality_reason
            timeseries_end_date
            timeseries_start_date
            __typename
          }
          unit
          value
          __typename
        }
        siteCode
        siteCodes
        siteId
        siteIds
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const listFunctionalEntities = /* GraphQL */ `
  query ListFunctionalEntities(
    $filter: FunctionalEntityFilterInput
    $limit: Int
    $sort: SortInput
  ) {
    listFunctionalEntities(filter: $filter, limit: $limit, sort: $sort) {
      items {
        airtable {
          analog_periods_without_data
          authorization_end_date
          automatic_upload
          building_tenths {
            building_tenth
            distribution_tenth
            distribution_tenth_comment
            organisation_tenant
            property_owner_tenth
            site_code
            site_id
            tenth
            __typename
          }
          consumption_2010_10years_in_kwh_pcs
          consumption_2011_10years_in_kwh_pcs
          consumption_2012_10years_in_kwh_pcs
          consumption_2013_10years_in_kwh_pcs
          consumption_2014_10years_in_kwh_pcs
          consumption_2015_10years_in_kwh_pcs
          consumption_2016_10years_in_kwh_pcs
          consumption_2017_10years_in_kwh_pcs
          consumption_2018_10years_in_kwh_pcs
          consumption_2019_10years_in_kwh_pcs
          consumption_2020_10years_in_kwh_pcs
          consumption_2021_10years_in_kwh_pcs
          consumption_2022_10years_in_kwh_pcs
          consumption_2023_10years_in_kwh_pcs
          consumption_2024_10years_in_kwh_pcs
          consumption_or_production
          contextual_information
          contract_holder
          current_synoptic_quality_reporting
          customer_space_available
          deet_category
          delegated_authorization
          deposited
          deposited_date
          destination
          distributor_name
          energy_data_upload_possibilities
          fluid_type
          functional_entities {
            code
            lots
            surface
            tenant_code
            tenant_name
            tertiary
            type
            __typename
          }
          injection_type
          last_analog_invoice_date
          named_authorization
          pdl_id
          perimeter_to_consider
          placement
          quality_of_data_completeness_2023
          questions_about_pdl_to_energy_manager
          site_code
          site_name
          site_rental_typology
          sites {
            address
            city
            code
            current_synoptic_quality_reporting
            id
            name
            organisation_tenant
            postal_code
            __typename
          }
          sub_metering
          supplier_name
          tenth
          unique_point
          usage
          __typename
        }
        buildingId
        id
        name
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const listPortfolios = /* GraphQL */ `
  query ListPortfolios(
    $filter: PortfolioFilterInput
    $limit: Int
    $sort: SortInput
  ) {
    listPortfolios(filter: $filter, limit: $limit, sort: $sort) {
      items {
        id
        name
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const listSites = /* GraphQL */ `
  query ListSites(
    $filter: SiteFilterInput
    $limit: Int
    $nextToken: String
    $sort: SortInput
  ) {
    listSites(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sort: $sort
    ) {
      items {
        airtable {
          acquisition_date
          address
          aegeon_energy_data_type
          altitude
          asl_aful_names
          asl_and_aful {
            name
            type
            __typename
          }
          asset_manager_contact {
            email
            name
            organizations_names
            phone_number
            role
            __typename
          }
          billing_contact {
            email
            name
            organizations_names
            phone_number
            role
            __typename
          }
          biodiversity_label
          building_site_plan
          city
          closing_hours
          co2_perf_bpe_oid_ref
          co_ownership {
            name
            type
            __typename
          }
          co_ownership_name
          code
          commissioning_and_reporting_note_2023
          construction_certification
          construction_date
          consumption_or_production
          counted_rental_typology
          crrem_typology
          current_synoptic_quality_reporting
          current_typology
          declared_detention_regime
          declared_ef_rental_areas
          declared_rental_typology
          deet_geographic_zone
          deet_subject
          deet_subject_case
          detention_contextual_information
          discontinued_data_questions
          disposal_date
          dpe_emissions
          dpe_energy
          efa_type
          energisme_energy_data_type
          energy_data_upload_possibilities
          esg_modality {
            name
            __typename
          }
          exhaustiveness_remaining_questions
          exploitation_certification
          final_energy_perf_bpe_oid_ref
          fluids_typology
          functional_entities {
            code
            lots
            surface
            tenant_code
            tenant_name
            tertiary
            type
            __typename
          }
          functional_entities_state_date
          google_maps_url
          gtb_presence
          indoor_parking
          initial_building_permit_date
          irves_presence
          last_dpe_date
          last_renovation_date
          latitude
          longitude
          maintainers_intervenants_contact {
            email
            name
            organizations_names
            phone_number
            role
            __typename
          }
          maintenance_company
          mandates_questions
          monitored_perimeter
          name
          number_of_buildings
          number_of_buildings_client
          number_of_indoor_parkings
          number_of_outdoor_parkings
          number_of_potentially_subjected_functional_entities
          number_of_tenants_following_rental_state_ex_parking
          opening_hours
          organization_type
          organizations {
            name
            type
            __typename
          }
          outdoor_parking
          perimeter_2023
          photovoltaic_presence
          postal_code
          powerpoint_synoptic
          previous_year_synoptic_validation
          property_manager_agency {
            name
            type
            __typename
          }
          property_manager_contact {
            email
            name
            organizations_names
            phone_number
            role
            __typename
          }
          reference_weather_station_city
          remaining_site_questions
          rental_manager_contact {
            email
            name
            organizations_names
            phone_number
            role
            __typename
          }
          rental_occupation_rate_2019
          rental_occupation_rate_2020
          rental_occupation_rate_2021
          rental_occupation_rate_2022
          rental_occupation_rate_2023
          rental_occupation_rate_2024
          reporting_end_date
          reporting_n_1_surface_energy_performance
          reporting_n_2_surface_energy_performance
          reporting_n_carbon_intensity
          reporting_n_reportable_site
          reporting_n_surface_energy_performance
          reporting_n_total_energy_consumption
          reporting_n_total_ghg_emissions
          reporting_n_total_water_consumption
          reporting_start_date
          rie_exploitation {
            name
            type
            __typename
          }
          rie_presence
          stakeholders_update_date
          synoptic_quality_reporting_2023
          synoptic_validation_note_2022_2023
          technical_assistant_contact {
            email
            name
            organizations_names
            phone_number
            role
            __typename
          }
          technical_contact {
            email
            name
            organizations_names
            phone_number
            role
            __typename
          }
          technical_documentation_technical_written_elements
          thermal_regulation
          third_party_parts_supply
          unified_degree_day_weather_station {
            city
            code
            __typename
          }
          updated_previous_year_tracking
          updated_year_tracking
          usage_crrem
          usage_dpe
          validated_client_hours
          validated_client_surface
          validated_client_working_days
          water_perf_bpe_oid_ref
          working_days
          year_synoptic_validation
          __typename
        }
        analysis {
          general {
            created_at
            text
            __typename
          }
          __typename
        }
        id
        name
        portfolioId
        properties {
          id
          name
          quality {
            completenes_end_date
            completenes_start_date
            completeness
            completeness_end_date
            completeness_start_date
            ignored_intervals {
              end_date
              start_date
              __typename
            }
            missing_values
            outliers {
              timestamp
              unit
              value
              __typename
            }
            overall_quality
            overall_quality_reason
            timeseries_end_date
            timeseries_start_date
            __typename
          }
          unit
          value
          __typename
        }
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const listSubdevices = /* GraphQL */ `
  query ListSubdevices(
    $filter: SubDeviceFilterInput!
    $limit: Int
    $nextToken: String
    $sort: SortInput
  ) {
    listSubdevices(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sort: $sort
    ) {
      items {
        building
        contract_holder
        description
        deviceId
        id
        lessor
        name
        siteId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers($filter: UserFilterInput) {
    listUsers(filter: $filter) {
      items {
        email
        enabled
        excludedPerimeter {
          devices
          sites
          __typename
        }
        id
        lastConnectionAt
        perimeter {
          devices
          sites
          __typename
        }
        role
        timeConstraintPerimeter {
          devices {
            id
            periods {
              endDate
              startDate
              __typename
            }
            __typename
          }
          sites {
            id
            periods {
              endDate
              startDate
              __typename
            }
            __typename
          }
          __typename
        }
        username
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
